import React, { Suspense, lazy } from 'react';
import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';
import ServiceMatrix from '@/components/ServiceMatrix';
import Footer from '@/components/Footer';
import Seo from '@/components/Seo';

const ProximityHub = lazy(() => import('@/components/ProximityHub'));
const BookingFlow = lazy(() => import('@/components/BookingFlow'));
const TrustSection = lazy(() => import('@/components/TrustSection'));
const FAQSection = lazy(() => import('@/components/FAQSection'));

export default function Home() {
  return (
    <>
      <Seo
        title="Garage Door Repair Cypress TX | 24/7 Emergency Service | Mike's Garage Door Repair"
        description="Mike's Garage Door Repair — Cypress TX's trusted 24/7 emergency garage door repair experts. Same-day spring replacement, opener repair, panel installation & off-track service. Call now."
        path="/"
      />
      <Navbar />
      <main>
        <Hero />
        <ServiceMatrix />
        <Suspense fallback={null}>
          <ProximityHub />
          <BookingFlow />
          <TrustSection />
          <FAQSection />
        </Suspense>
      </main>
      <Footer />
    </>
  );
}